import { darken, Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';
import { isHexColor, isRgbColor } from 'class-validator';

export const priceTierCardStyles = (theme: Theme, isSoldOut = false) => ({
	groupTierType: {
		p: '5px 12px',
		backgroundColor: Colors.black_a40,
		borderRadius: '25px',
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '12px',
		fontWeight: 700,
		lineHeight: '15px',
		color: Colors.white,
		textTransform: 'uppercase',
	},
	soldoutFontSx: (color?: string) => ({
		color: color ? (isHexColor(color) || isRgbColor(color) ? darken(color, 0.1) : undefined) : Colors.white_a90,
	}),
	tierName: {
		fontFamily: 'Montserrat',
		fontSize: '15px',
		lineHeight: '18px',
		fontWeight: 700,
		color: Colors.white,
		flex: 1,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	tierSoldOut: {
		p: '4px 12px 4px 6px',
		backgroundColor: Colors.white_a10,
		border: `1px solid ${Colors.white_a20}`,
		borderRadius: '30px',
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '13px',
		fontWeight: 600,
		lineHeight: '21px',
		color: Colors.white,
	},
	ticketsAvailable: {
		fontFamily: 'Montserrat',
		fontSize: '13px',
		fontWeight: 500,
		lineHeight: '16px',
		color: Colors.white,
		width: 'fit-content',
	},
	tierDescription: {
		fontFamily: 'Montserrat',
		fontSize: '13px',
		lineHeight: '21px',
		fontWeight: 500,
		color: '#FFFFFFE5',
	},
	quantityBox: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		minWidth: '100px',
		gap: '10px',
	},
	quantityButton: {
		border: '1px solid #FFFFFF33',
		borderRadius: '50%',
		minWidth: '24px',
		minHeight: '24px',
		fontSize: '12px',
		color: '#FFFFFF',
		opacity: isSoldOut ? 0.5 : 1,

		'& svg': {
			fontSize: '18px',
		},

		'&:hover': {
			backgroundColor: '#FFFFFF',
			color: '#000000',
		},

		'&:disabled': {
			opacity: 0.5,
		},
	},
	quantity: {
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '17px',
		lineHeight: '20px',
		color: '#FFFFFF',
		userSelect: 'none',
		opacity: isSoldOut ? 0.5 : 1,
	},
	price: {
		fontFamily: 'Montserrat',
		fontSize: '15px',
		fontWeight: 700,
		lineHeight: '18px',
		color: '#FFFFFF',
	},
	joinWaitlistButton: {
		p: '10px 24px',
		width: '140px',
		maxHeight: '37px',
		fontSize: '14px',
		fontFamily: 'Montserrat, sans-serif',
		textTransform: 'unset',
		fontWeight: 600,
		borderColor: 'currentColor',

		'&:hover': {
			borderColor: 'currentColor',
		},
	},
});
